import { TGetDocumentByPageParams } from '@/services';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IPayloadGetDefineDocumentDownloadListSuccess,
	TDefineDocumentDownloadDetailStore,
	TPayloadDefineDownloadDocumentRequest,
	TPayloadGetDefineDocumentDownloadListRequest,
} from './define-document-download.type';

const initialState = {
	fetching: false,
	defineDocumentDownloadList: [] as TDefineDocumentDownloadDetailStore[],
	params: {} as TGetDocumentByPageParams,
};

const defineDocumentDownloadSlice = createSlice({
	initialState,
	name: 'defineDocumentDownload',
	reducers: {
		/**---- GET DEFINE_DOCUMENT_DOWNLOAD LIST START ---- */
		getDefineDocumentDownloadListRequest: (
			state,
			action: PayloadAction<TPayloadGetDefineDocumentDownloadListRequest>
		) => {
			state.fetching = true;
			state.params = action.payload;
		},
		getDefineDocumentDownloadListSuccess: (
			state,
			action: PayloadAction<IPayloadGetDefineDocumentDownloadListSuccess>
		) => {
			const { defineDocumentDownloadList } = action.payload;
			state.fetching = false;
			state.defineDocumentDownloadList = defineDocumentDownloadList;
		},
		getDefineDocumentDownloadListFailure: (state) => {
			state.fetching = false;
		},
		/**---- GET DEFINE_DOCUMENT_DOWNLOAD LIST END ---- */

		/**---- DOWNLOAD DOCUMENT START ---- */

		downloadDefineDocumentByIdsRequest: (
			state,
			action: PayloadAction<TPayloadDefineDownloadDocumentRequest>
		) => {
			state.fetching = true;
		},

		downloadDefineDocumentsRequest: (
			state,
			action: PayloadAction<TPayloadDefineDownloadDocumentRequest>
		) => {
			state.fetching = true;
		},

		downloadDefineDocumentsSuccess: (state) => {
			state.fetching = false;
		},

		downloadDefineDocumentsFailure: (state) => {
			state.fetching = false;
		},

		/**---- DOWNLOAD DOCUMENT END ---- */
	},
});

export const DefineDocumentDownloadSelectors = {
	selectFetching: (state: RootState) => state.defineDocumentDownload.fetching,
	selectList: (state: RootState) =>
		state.defineDocumentDownload.defineDocumentDownloadList,
	selectParams: (state: RootState) => state.defineDocumentDownload.params,
};

export const DefineDocumentDownloadActions =
	defineDocumentDownloadSlice.actions;
export const DefineDocumentDownloadReducer =
	defineDocumentDownloadSlice.reducer;
